import * as React from 'react'
import { customerMarketShopfrontApi } from '@envato/foundation-types'

import * as styles from './elementsBannerBlock.module.css'

import { IBlockMatchedComponent } from '../../../pages/category/category'
import { reportCategoryPageClick } from '../../../../common/analytics/categoryPageAnalytics'

interface IProps extends IBlockMatchedComponent {
  cta: customerMarketShopfrontApi.categoryPage.ICta
  desktopImage: string
}

const ElementsBannerBlock = ({
  title,
  subtitle,
  cta,
  desktopImage
}: IProps) => {
  return (
    <article>
      <a
        href={cta.url}
        className={styles.banner}
        target="_blank"
        rel="noopener noreferrer"
        onClick={reportCategoryPageClick('Elements full width banner')}
      >
        <div className={styles.detail}>
          <header>
            <h2 className={styles.title}>{title}</h2>
            <h3 className={styles.subtitle}>{subtitle}</h3>
          </header>

          <button className={styles.button}>{cta.title}</button>
        </div>
        <div className={styles.imageWrapper}>
          <img className={styles.image} src={desktopImage} alt={styles.title} />
        </div>
      </a>
    </article>
  )
}

export default ElementsBannerBlock
